module.exports = __webpack_public_path__ + "media/slime.654a6c6d.wav";